import { IGetIssueLogPlusResourcesResultData, ILogPlusAccessoryData, ILogPlusAgreementData, ILogPlusComputerData, ILogPlusDataCarrierData, ILogPlusItSystemData, ILogPlusLicenseData, ILogPlusMobileDeviceData, ILogPlusMonitorData, ILogPlusNetworkDeviceData, ILogPlusPersonData, ILogPlusPhoneNumberData, ILogPlusPrinterData, ILogPlusServiceData } from "../../services/useLogPlusResourcesApi";
import { IData, KindsList, IAgreementListItem, IDeviceListItem, IItSystemListItem, ILicenseListItem, IPersonListItem, IServiceListItem } from "./IModels";

export function parseIssueLogResourceToValue(source: IGetIssueLogPlusResourcesResultData, kinds: KindsList[]): IData {

	let result = {} as IData;
	for (let prop in source) {

		var supported = kinds.filter(x => x === prop).length > 0;
		if (!supported)
			continue;

		if (source[prop]) {
			let fnParse;
			switch (prop as KindsList) {
				case "Person": fnParse = parseFromValuePerson; break;
				case "ItSystem": fnParse = parseFromValueItSystem; break;
				case "Agreement": fnParse = parseFromValueAgreement; break;
				case "License": fnParse = parseFromValueLicense; break;
				case "Service": fnParse = parseFromValueService; break;

				case "Computer": fnParse = parseFromValueComputer; break;
				case "DataCarrier": fnParse = parseFromValueDataCarrier; break;
				case "MobileDevice": fnParse = parseFromValueMobileDevice; break;
				case "Monitor": fnParse = parseFromValueMonitor; break;
				case "NetworkDevice": fnParse = parseFromValueNetworkDevice; break;
				case "Printer": fnParse = parseFromValuePrinter; break; 
				case "Accessory": fnParse = parseFromValueAccessory; break; 
				case "PhoneNumber": fnParse = parseFromValuePhoneNumber; break; 
			}

			result[prop] = source[prop].map(fnParse)
		}
	};

	return result;
}

function parseFromValuePerson(data: ILogPlusPersonData): IPersonListItem {
	return {
		...data,
		Id: data.LogId,
		UserName: null,
		Cellphone: null,
		Company: null,
		MpkNumber: null,
		Status: null,
		WorkPhone: null,
	}
}

function parseFromValueItSystem(data: ILogPlusItSystemData): IItSystemListItem {
	return {
		...data,
		Id: data.LogId,
		EnvironmentType: null,
		Status: null,
	}
}

function parseFromValueAgreement(data: ILogPlusAgreementData): IAgreementListItem {
	return {
		...data,
		Id: data.LogId,
		Status: null,
		ValidFrom: null,
		ValidTo: null,
	}
}

function parseFromValueLicense(data: ILogPlusLicenseData): ILicenseListItem {
	return {
		...data,
		Id: data.LogId,
		Status: null,
	}
}

function parseFromValueService(data: ILogPlusServiceData): IServiceListItem {
	return {
		...data,
		Id: data.LogId,
		Status: null,
		CommercialDescription: null,
		Validity: null,
	}
}

function parseFromValueComputer(data: ILogPlusComputerData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "Computer",
		Status: null,
	}
}

function parseFromValueDataCarrier(data: ILogPlusDataCarrierData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "DataCarrier",
		Status: null,
	}
}

function parseFromValueMobileDevice(data: ILogPlusMobileDeviceData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "MobileDevice",
		Status: null,
	}
}

function parseFromValueMonitor(data: ILogPlusMonitorData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "Monitor",
		Status: null,
	}
}

function parseFromValueNetworkDevice(data: ILogPlusNetworkDeviceData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "NetworkDevice",
		Status: null,
	}
}

function parseFromValuePrinter(data: ILogPlusPrinterData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "Printer",
		Status: null,
	}
}

function parseFromValueAccessory(data: ILogPlusAccessoryData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "Accessory",
		Status: null,
	}
}

function parseFromValuePhoneNumber(data: ILogPlusPhoneNumberData): IDeviceListItem {
	return {
		...data,
		Id: data.LogId,
		HdKind: "PhoneNumber",
		Status: null,
	}
}